import React, { useState } from "react";
import TeamOverview from "./TeamOverview";
import PressFeeTracker from "./PressFeeTracker";
import MyHistory from "./MyHistory";
import TeamBottomNav from "./TeamBottomNav";
import "./AdminTeamPreview.css";

export default function AdminTeamPreview({ onExit }) {
  const [tab, setTab] = useState("overview");

  return (
    <div className="admin-team-preview">
      <div className="admin-preview-bar">
        <div className="admin-preview-bar__inner">
          <div className="admin-preview-copy">
            <span className="admin-preview-badge">ADMIN PREVIEW</span>
            <div>
              <strong>กำลังดูเว็บในมุมทีม</strong>
              <small>สิทธิ์แอดมินยังอยู่เหมือนเดิม และโหมดนี้จะไม่บันทึก/ลบข้อมูลจริง</small>
            </div>
          </div>
          <button type="button" className="admin-preview-exit" onClick={onExit}>
            ← กลับหน้าแอดมิน
          </button>
        </div>
      </div>

      <div className="admin-preview-content">
        {tab === "overview" && <TeamOverview setTab={setTab} />}
        {tab === "tracker" && <PressFeeTracker previewMode />}
        {tab === "history" && <MyHistory readOnly />}
      </div>

      <TeamBottomNav
        currentTab={tab}
        setTab={setTab}
        previewMode
        onExitPreview={onExit}
      />
    </div>
  );
}
